(function () {
    'use strict';

    /**
    * blocks.logger Module
    *
    * Description used to log readable information to console.
    */
    angular.module('blocks.logger', []);

})();
